export default {
    1: 'Per Hour',
    2: 'Per Month',
    3: 'Cost Plus',
    PerHour: 1,
    PerMonth: 2,
    CostPlus: 3
}

// Payment types the customer-wide header selector may set. Cost Plus is
// deliberately absent: it is a per-employee contract change, reachable only
// from the New Rate strip on the row it applies to, so choosing a customer
// default can never convert one employee's cost-plus rate back to hourly.
export const customerDefaultDurationTypes = [1, 2]

// A rate row carries an explicit per-employee override when its payment type
// is Cost Plus. Overridden rows are skipped by the header's bulk-apply;
// Per Hour / Per Month rows follow the customer default.
export const isDurationTypeOverride = durationType => durationType === 3
